// extracted by mini-css-extract-plugin
module.exports = {"loginPage":"loginPage___1KyOm"};